export const TimeDataSelNotFromTo = [{
    displayvalue: 'Tuần',
    val: 'week',
  }, {
    displayvalue: 'Tháng',
    val: 'month',
  }, {
    displayvalue: 'Năm',
    val: 'year',
  }, {
    displayvalue: 'Quý',
    val: 'quarter',
  }
];

export const TimeDataSel = [{
  displayvalue: 'Tuần',
  val: 'week',
}, {
  displayvalue: 'Tháng',
  val: 'month',
}, {
  displayvalue: 'Năm',
  val: 'year',
}, {
  displayvalue: 'Quý',
  val: 'quarter',
}, {
  displayvalue: 'Khoảng thời gian',
  val: 'RangePicker',
}
];

export const TimeDataSelCompareCompanySales = [{
  displayvalue: 'Tuần',
  val: 'week',
}, {
  displayvalue: 'Tháng',
  val: 'month',
}, {
  displayvalue: 'Năm',
  val: 'year',
}
];